import { Filter } from 'mk/bazaar/product/filter/filterUtils';
import { FacetsData } from 'mk2/apps/bazaar/components/FacetsFilter';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

export interface Checked {
    [productId: number]: true;
}

export interface HerBazaarLoadApiAction extends Action {
    readonly username: string;
    readonly filter: Filter;
}

export const HER_BAZAAR_LOAD_API_REQUEST = 'HER_BAZAAR_LOAD_API_REQUEST';

export interface HerBazaarLoadApiRequestAction extends HerBazaarLoadApiAction, APIRequestAction {
    readonly type: typeof HER_BAZAAR_LOAD_API_REQUEST;
}

export interface HerBazaarLoadNormalizedResponse extends NormalizedResponse {
    readonly result: {
        seller: number;
        products: number[];
        complaints: {
            [productId: number]: number[];
        };
    };
}

export const HER_BAZAAR_LOAD_API_SUCCESS = 'HER_BAZAAR_LOAD_API_SUCCESS';

export interface HerBazaarLoadApiSuccessAction
    extends HerBazaarLoadApiAction,
        APISuccessAction<HerBazaarLoadNormalizedResponse> {
    readonly type: typeof HER_BAZAAR_LOAD_API_SUCCESS;
    readonly facets: FacetsData;
    readonly hits: number;
    readonly checked: Checked;
}

export const HER_BAZAAR_LOAD_API_FAILURE = 'HER_BAZAAR_LOAD_API_FAILURE';

export interface HerBazaarLoadApiFailureAction extends HerBazaarLoadApiAction, APIFailureAction {
    readonly type: typeof HER_BAZAAR_LOAD_API_FAILURE;
}

export const herBazaarLoadApi = {
    request: (username: string, filter: Filter): HerBazaarLoadApiRequestAction => ({
        type: HER_BAZAAR_LOAD_API_REQUEST,
        username,
        filter,
    }),
    success: (
        username: string,
        filter: Filter,
        facets: FacetsData,
        hits: number,
        checked: Checked,
        response: HerBazaarLoadNormalizedResponse,
    ): HerBazaarLoadApiSuccessAction => ({
        type: HER_BAZAAR_LOAD_API_SUCCESS,
        username,
        filter,
        facets,
        hits,
        checked,
        response,
    }),
    failure: (username: string, filter: Filter, error: any): HerBazaarLoadApiFailureAction => ({
        type: HER_BAZAAR_LOAD_API_FAILURE,
        username,
        filter,
        error,
    }),
};

export const HER_BAZAAR_LOAD = 'HER_BAZAAR_LOAD';

export interface HerBazaarLoadAction extends HerBazaarLoadApiAction {
    readonly type: typeof HER_BAZAAR_LOAD;
}

export const herBazaarLoad = (username: string, filter: Filter): HerBazaarLoadAction => ({
    type: HER_BAZAAR_LOAD,
    username,
    filter,
});
